import type { TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateVirtualSelectAllExclusionList',
    function updateVirtualSelectAllExclusionList(tableView: TableView, rowKey: string) {
        // Update row exclusion list in select all mode when a user selects/unselects any row.
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (11,26): Object is possibly 'undefined'.
        // @ts-expect-error
        const rowIndex = tableView.virtualSelectAllExclusionList.indexOf(rowKey);
        if (rowIndex > -1) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (16,13): Object is possibly 'undefined'.
            // @ts-expect-error
            tableView.virtualSelectAllExclusionList.splice(rowIndex, 1);
        } else {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (21,13): Object is possibly 'undefined'.
            // @ts-expect-error
            tableView.virtualSelectAllExclusionList.push(rowKey);
        }
    }
);
